import React from 'react';
import PropTypes from 'prop-types';

function EditorSidebarContainer({
    height,
    width,
    children,
}) {
    return (
        <div className="ViewTableMenuContainer" style={{ height: height || "100%", width: width }}>
            <div id="treeDiv" className="InternalScrollDiv1">
                <div className="editorTableContainer">
                    <div className="editorTable">
                        { children }
                    </div>
                </div>
            </div>
        </div>
    );
}

EditorSidebarContainer.propTypes = {
    height: PropTypes.number.isRequired,
    children: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default EditorSidebarContainer;